import { PersistedAppStateV1 } from '../schemas/persisted-app-state-v1.model';
import { PersistedAppStateV2 } from '../schemas/persisted-app-state-v2.model';

export function migratePersistedAppStateV1ToV2(state: PersistedAppStateV1): PersistedAppStateV2 {
  return {
    ...state,
    schemaVersion: 2,
    cards: state.cards.map((card) => ({
      ...card,
      ladderGroupColor: card.ladderGroupColor ?? null,
    })),
  };
}